import React from "react";
import { useDragLayer } from "react-dnd";
import { metricDataType } from "../../../../providers/dataPlatformReportTypes";
import MetricCard from "../score/MetricCard";
import BiomarkerCard from "../score/BiomarkerCard";
import useTheme from "../../../../common/hooks/useTheme";
import { isMobile } from "react-device-detect";

type DraggedItem = {
  id: string;
  index: number;
  fromSelected: boolean;
  type: string;
  card: metricDataType;
};

const layerStyles: React.CSSProperties = {
  position: "fixed",
  pointerEvents: "none",
  zIndex: 1000,
  left: 0,
  top: 0,
  width: isMobile ? "80%" : "270px",
  height: "100%",
};

const getItemStyles = (initialOffset: any, currentOffset: any) => {
  if (!initialOffset || !currentOffset) return { display: "none" };
  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
};

const CustomDragLayer: React.FC = () => {
  const theme = useTheme();
  const { item, itemType, isDragging, initialOffset, currentOffset } =
    useDragLayer((monitor) => ({
      item: monitor.getItem() as DraggedItem,
      itemType: monitor.getItemType(),
      isDragging: monitor.isDragging(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
    }));

  if (!isDragging || !item.card) return null;

  const style = getItemStyles(initialOffset, currentOffset);

  return (
    <div style={layerStyles}>
      <div style={{ ...style, backgroundColor: "#fff", borderRadius: 8 }}>
        {item.type === "metric" && (
          <MetricCard
            item={item.card}
            categories={[]} // You can inject scoreCategories here if needed
            withShadow={true}
            isClickable={false}
          />
        )}
        {item.type === "biomarker" && (
          <BiomarkerCard
            item={item.card}
            index={item.index}
            isClickable={false}
          />
        )}
      </div>
    </div>
  );
};

export default CustomDragLayer;
